module.exports = __webpack_public_path__ + "img/icon_home_bottom.79b50811.svg";